import styled from "styled-components/macro";
import {Input} from "./Content";

export interface InputProps {
    error?: string
}

export const InputSearchContainer = styled.div`
  width: 100%;
  padding: 0;
  position: relative;

  ${Input} {
    margin-bottom: 8px;
  }
`
export const InputStringError = styled.div<InputProps>`
  display: ${props => props.error ? 'flex' : 'none'};
  text-align: start;
  color: red;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  width: 100%;
  margin-top: -10px;
  margin-bottom: 10px;
  white-space: break-spaces;
`

export const RegisterInputContainer = styled.div`
  width: 100%;
    position: relative;
  .PhoneInput {
    input[type='tel'] {
      height: 56px;
      padding-left: 55px;
    }
  }

  .registerPhoneInput {
    padding-left: 0 !important;
    border: none;
    height: 33px;
  }
  .phone-code {
    margin: 1px 0;
  }

  ${InputStringError} {
    top: 75px;
  }

`

export const ButtonContainer= styled.div`
  display: flex;
  justify-content: space-between;

`
export const ChangeDateError = styled.div<InputProps>`
  display: ${props => props.error ? 'flex' : 'none'};
  top: 40px;
  position: absolute;
  color: red;
  font-weight: 300;
  font-size: 12px;
  left: 2px;
  font-style: normal;
  line-height: 16px;
  text-align: left;
  margin-left: 6px;
`
export const InputIconContainer = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  //width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({theme}) => theme.color.primaryBackground};

  :hover {
    background-color: ${({theme}) => theme.color.secondaryBackground};
  }
`;

export const InputSearchDataContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  overflow: visible;
`
export const InputSearchDataList = styled.div`
  padding: 0;
  position: absolute;
  top: 45px;
  display: flex;
  background: ${({theme}) => theme.color.primaryBackground};
  flex-direction: column;
  max-height: 256px;
  overflow-y: scroll;
  z-index: 5;
  box-shadow: 0 2px 4px rgba(105, 105, 105, 0.25), 0 4px 10px rgba(105, 105, 105, 0.15);
  border-radius: 4px;

`
export const InputSearchDataItem = styled.div`
  width: 90%;
  cursor: pointer;
  padding: 12px;
  display: flex;
  gap: 4px;
  flex-direction: column;
  justify-content: center;
`
export const SecurityInputContainer = styled.div`
  width: 100%;
  .security-input {
    height: 56px;
  }
  .phone {
    padding-left: 0 !important;
    border: none;
    height: 33px;
  }
  ${InputStringError} {
    margin-top: -13px;
    margin-bottom: 7px;
  }
`

export const ForgotPassword = styled.div`
  margin-top: 12px;
  margin-right: auto;
`

export const RecoveryInputContainer = styled.div`
  margin-bottom: 0;
  position: relative;
  input {
    height: 65px !important;
  }
`

export const RecoveryCodeContent = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
`

export const PhoneInputStringError = styled.div<InputProps>`
  display: ${props => props.error ? 'flex' : 'none'};
  top: 62px;
  position: absolute;
  color: red;
  font-weight: 300;
  font-size: 12px;
  left: 2px;
  font-style: normal;
  line-height: 16px;
  text-align: left;
  margin-left: 6px;
  z-index: 0;
`


export const LoginInputContainer = styled.div`
  position: relative;
  width: 100%;
${InputIconContainer} {
  right: 45px;
}
`

export const ErrorSpan = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({theme}) => theme.color.danger};
  margin-top: 8px;
`

export const InputSpan = styled.span`
  position: absolute;
  top: 5px;
  left: 10px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
color: #898F97


`
